import { Box } from '@mui/material'
import GroupIcon from '@mui/icons-material/Group'
import { PermissionCard } from '../common'
import {
  PermissionCheckboxList,
  TeamPermissions as TeamPermissionsType,
  PERMISSION_LABELS,
} from './PermissionCheckboxList'

interface TeamPermissionsProps {
  permissions: TeamPermissionsType
  onToggle: (key: keyof TeamPermissionsType, value: boolean) => void
  disabled?: boolean
  isMobile?: boolean
}

export function TeamPermissionsComponent({
  permissions,
  onToggle,
  disabled = false,
  isMobile = false,
}: TeamPermissionsProps) {
  // Sabit izin sayısı - PERMISSION_LABELS'deki key sayısı
  const TOTAL_PERMISSION_COUNT = Object.keys(PERMISSION_LABELS).length
  const enabledCount = (Object.keys(PERMISSION_LABELS) as (keyof TeamPermissionsType)[])
    .filter((key) => permissions[key] === true).length

  return (
    <PermissionCard
      title="Takım İzinleri"
      subtitle={`${enabledCount}/${TOTAL_PERMISSION_COUNT} izin aktif`}
      icon={<GroupIcon />}
      headerColor="secondary"
      height={isMobile ? 'auto' : '100%'}
    >
      <Box
        sx={{
          height: isMobile ? 'auto' : '100%',
          maxHeight: isMobile ? '400px' : '100%',
          overflow: 'auto',
        }}
      >
        <PermissionCheckboxList
          permissions={permissions}
          onChange={onToggle}
          disabled={disabled}
          showCategories={true}
        />
      </Box>
    </PermissionCard>
  )
}
